import * as React from "react";

const dailyHeaderItems = [
    { text: "순번", width: "80px", icon: null },
    { text: "이름", width: "110px", icon: "/images/icon-user.svg" },
    { text: "첫번째 학습", width: "120px", icon: "/images/icon-hexagon-number-1_gray_2.svg" },
    { text: "두번째 학습", width: "120px", icon: "/images/icon-hexagon-number-2_gray_2.svg" },
    { text: "세번째 학습", width: "120px", icon: "/images/icon-hexagon-number-3_gray_2.svg" },
    { text: "학습결과 분석", width: "440px", icon: "/images/icon-result.svg"}
];

const TableHeaderDaily = () => {
    return (
        <thead>
        <tr className="flex flex-wrap items-center text-base font-semibold bg-sky-50 rounded-t-3xl text-slate-400 max-md:max-w-full">
            <th
                className={`flex gap-1 justify-center items-center self-stretch px-2 py-5 my-auto min-h-[56px] w-[${dailyHeaderItems[0].width}]`}
            >
                <div className="self-stretch my-auto">{dailyHeaderItems[0].text}</div>
            </th>
            <th
                className={`flex gap-1 justify-center items-center self-stretch px-2 py-5 my-auto min-h-[56px] w-[${dailyHeaderItems[1].width}]`}
            >
                <img
                    loading="lazy"
                    src={dailyHeaderItems[1].icon}
                    alt="icon"
                    className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                />
                <div className="self-stretch my-auto">{dailyHeaderItems[1].text}</div>
            </th>
            <th
                className="flex gap-1 justify-center items-center self-stretch px-2 py-5 my-auto min-h-[56px] w-[360px]"
            >
                <div className={`flex gap-1 justify-center items-center w-[${dailyHeaderItems[2].width}]`}>
                    <img
                        loading="lazy"
                        src={dailyHeaderItems[2].icon}
                        alt="icon"
                        className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                    />
                    <div className="self-stretch my-auto">{dailyHeaderItems[2].text}</div>
                </div>
                <div className={`flex gap-1 justify-center items-center w-[${dailyHeaderItems[3].width}]`}>
                    <img
                        loading="lazy"
                        src={dailyHeaderItems[3].icon}
                        alt="icon"
                        className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                    />
                    <div className="self-stretch my-auto">{dailyHeaderItems[3].text}</div>
                </div>
                <div className={`flex gap-1 justify-center items-center w-[${dailyHeaderItems[4].width}]`}>
                    <img
                        loading="lazy"
                        src={dailyHeaderItems[4].icon}
                        alt="icon"
                        className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                    />
                    <div className="self-stretch my-auto">{dailyHeaderItems[4].text}</div>
                </div>
            </th>
            <th
                className={`flex gap-1 justify-center items-center self-stretch px-2 py-5 my-auto min-h-[56px] w-[${dailyHeaderItems[5].width}]`}
            >
                <img
                    loading="lazy"
                    src={dailyHeaderItems[5].icon}
                    alt="icon"
                    className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                />
                <div className="self-stretch my-auto">{dailyHeaderItems[5].text}</div>
            </th>
        </tr>
        </thead>
    );
}

export default TableHeaderDaily;